import classNames from "classnames";

import { useLongPress } from "../hooks/use-long-press";

export interface OverlayButtonProps {
  position: "left" | "right";
  onLongPress?: () => void;
  onLongPressReleased?: () => void;
  onPress?: () => void;
}

export function OverlayButton(props: OverlayButtonProps) {
  const { position, onLongPress, onLongPressReleased, onPress } = props;

  const { onClear: _onClear, ...buttonProps } = useLongPress({
    delay: 500,
    shouldPreventDefault: true,
    onLongPress: () => onLongPress?.(),
    onLongPressReleased: () => onLongPressReleased?.(),
    onPress: () => onPress?.(),
  });

  return (
    <button
      {...buttonProps}
      type="button"
      data-test-id={`overlay-${position}`}
      className={classNames("lookbook--story--item--overlay", {
        "lookbook--story--item--overlay--left": position === "left",
        "lookbook--story--item--overlay--right": position === "right",
      })}
      tabIndex={onPress ? 0 : -1}
      disabled={!onPress}
    />
  );
}
